export default __webpack_public_path__ + "static/media/loading.cf88915e.png";